<template>
  <div class="autocomplete-input">
    <div class="control has-icon has-icon-right">
      <input
        v-model="local_keyword"
        class="form-control"
        placeholder="Napište název plemene"
        @input="onInput($event.target.value)"
        @keyup.esc="isOpen = false"
        @click="click"
        @keydown.down="moveDown"
        @keydown.up="moveUp"
        @keydown.enter="select"
      >
      <i class="fa fa-angle-down"></i>
    </div>
    <div v-show="isOpen" class="autocomlete-items">
      <div class="autocomlete-item" v-for="(option, index) in fOptions"
           :class="{'highlighted': index === highlightedPosition}"
           @mouseenter="highlightedPosition = index" @mousedown="select">

        <img :alt="option.title" :src="getOptionSmallImageUrl(option)">
        <strong>{{ option.title }} <span v-if="option.slang.length > 0" class="slang">({{ option.slang }})</span></strong>
      </div>
    </div>
  </div>
</template>

<script>
  import imageService from '../services/image-service'

  export default {
    props: {
      options: {
        type: Array,
        required: true
      },
      keyword: {
        type: String,
        required: false
      }
    },
    data: function () {
      return {
        isOpen: false,
        highlightedPosition: 0,
        local_keyword: this.keyword,
        raceSmallImagesUrl: imageService.RACE_SMALL_IMAGES_URL
      }
    },
    computed: {
      fOptions() {
        const re = new RegExp(this.local_keyword, 'i')
        return this.options.filter(o => o.title.match(re) || o.slang.match(re))
      }
    },
    methods: {
      getOptionSmallImageUrl(option) {
        return option.rasa_obrazek_small_url !== "" ? option.rasa_obrazek_small_url : this.raceSmallImagesUrl + option.title_en + '.png'
      },
      onInput(value) {
        this.highlightedPosition = 0
        this.isOpen = !!value
      },
      moveDown() {
        if (!this.isOpen) {
          return
        }
        this.highlightedPosition = (this.highlightedPosition + 1) % this.fOptions.length
      },
      moveUp() {
        if (!this.isOpen) {
          return
        }
        this.highlightedPosition = this.highlightedPosition - 1 < 0 ? this.fOptions.length - 1 : this.highlightedPosition - 1
      },
      click() {
        this.isOpen = !this.isOpen
      },
      select() {
        const selectedOption = this.fOptions[this.highlightedPosition]
        this.$emit('select', selectedOption)
        this.isOpen = false
        this.local_keyword = selectedOption.title
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Autocomplete.vue?cf57c47a